/* ABCC native French mode — text applier, language toggle, dynamic-content observer.
   Dictionary comes from abcc-fr-dict.js (core) + abcc-fr-titles.js (product titles).
   Deterministic: no external service, no races. FR mode is driven by
   window.ABCC_LANG (set by the head script) + localStorage 'abccLang'. */
(function () {
  'use strict';

  var LANG_KEY = 'abccLang';
  var DICT = window.ABCC_FR || {};
  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, OPTION: 1 };
  var ATTRS = ['placeholder', 'aria-label', 'title', 'alt'];

  function tr(s) {
    if (!s) return s;
    var t = s.trim();
    if (t && DICT[t]) return s.replace(t, DICT[t]);
    return s;
  }

  function translateTextNode(n) {
    var v = tr(n.nodeValue);
    if (v !== n.nodeValue) n.nodeValue = v;
  }

  function translateAttrs(el) {
    if (!el.hasAttribute) return;
    for (var i = 0; i < ATTRS.length; i++) {
      var a = ATTRS[i];
      if (el.hasAttribute(a)) {
        var cur = el.getAttribute(a);
        var v = tr(cur);
        if (v !== cur) el.setAttribute(a, v);
      }
    }
  }

  function walk(root) {
    var it = document.createNodeIterator(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode;
        if (!p || SKIP_TAGS[p.tagName]) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var n;
    while ((n = it.nextNode())) translateTextNode(n);
    var sel = '[' + ATTRS.join('],[') + ']';
    var els = root.querySelectorAll ? root.querySelectorAll(sel) : [];
    for (var i = 0; i < els.length; i++) translateAttrs(els[i]);
    if (root.nodeType === 1) translateAttrs(root);
  }

  function applyFr() {
    if (window.ABCC_LANG !== 'fr') return;
    if (document.body) walk(document.body);
    // page <title>: translate each segment (e.g. "Product Title - AB Crystal Collection")
    try {
      if (document.title) {
        var parts = document.title.split(/(\s+[-\u2013|]\s+|\s\|\s)/);
        var out = parts.map(function (p) { return tr(p); }).join('');
        if (out !== document.title) document.title = out;
      }
    } catch (e) {}
  }

  /* ---------- language toggle ---------- */
  function setLang(l) {
    try { localStorage.setItem(LANG_KEY, l); } catch (e) {}
    // switch between native /fr URLs (Translate & Adapt); JS dictionary fills any gaps
    try {
      var path = location.pathname;
      var onFr = /^\/fr(\/|$)/.test(path);
      var target = null;
      if (l === 'fr' && !onFr) target = '/fr' + path;
      else if (l === 'en' && onFr) target = path.replace(/^\/fr/, '') || '/';
      var url = new URL(window.location.href);
      url.searchParams.delete('lang');
      if (target) {
        url.pathname = target;
        window.location.href = url.toString();
      } else {
        window.location.href = url.toString();
      }
    } catch (e) {
      window.location.reload();
    }
  }

  function injectToggle() {
    if (document.querySelector('.abcc-lang-toggle')) return;
    var host = document.body;
    if (!host) return;
    var cur = window.ABCC_LANG === 'fr' ? 'fr' : 'en';
    var d = document.createElement('div');
    d.className = 'abcc-lang-toggle';
    d.innerHTML = '<a href="#" data-l="en">EN</a><span>|</span><a href="#" data-l="fr">FR</a>';
    var links = d.querySelectorAll('a');
    for (var i = 0; i < links.length; i++) {
      (function (a) {
        if (a.getAttribute('data-l') === cur) a.classList.add('on');
        a.addEventListener('click', function (e) {
          e.preventDefault();
          if (a.getAttribute('data-l') !== cur) setLang(a.getAttribute('data-l'));
        });
      })(links[i]);
    }
    host.appendChild(d);
  }

  /* ---------- boot ---------- */
  function boot() {
    injectToggle();
    applyFr();
    // dynamic content (quick view, cart drawer, search results, infinite scroll)
    try {
      new MutationObserver(function (muts) {
        if (window.ABCC_LANG !== 'fr') return;
        for (var i = 0; i < muts.length; i++) {
          var nodes = muts[i].addedNodes;
          for (var j = 0; j < nodes.length; j++) {
            var n = nodes[j];
            if (n.nodeType === 3) {
              if (n.parentNode && !SKIP_TAGS[n.parentNode.tagName]) translateTextNode(n);
            } else if (n.nodeType === 1 && !SKIP_TAGS[n.tagName]) {
              walk(n);
            }
          }
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
